module.exports = __webpack_public_path__ + "img/107020.28892df1.png";